import React from "react";
import StyledArticleContent from "./StyledArticleContent";
import parseShortcodesInString from "../../utilities/parseShortcodesInString";
import { shortcodes } from "../../utilities/shortcodes";

const ArticleContent = ({ article }) => {

  const title = article.title;
  const id = article.id;

  const formatArticle = article => {
    if (article.content) {
      article.parsedContent = parseShortcodesInString(article.content);
    }
    return article;
  }

  const parsedContent = formatArticle(article);

  let content = article.parsedContent;
  content = content.map((chunk, i) => {
    if (chunk.type === 'string') {
      return <div key={`string-${id}-${i}`} dangerouslySetInnerHTML={{ __html: chunk.content }} />
    } else {
      const Element = shortcodes[chunk.name].component
      return <Element
        key={`${chunk.name}-${id}-${i}`}
        name={chunk.name}
        title={title}
        postId={id}
        {...chunk.attributes.named} />
    }
  })
  return (
    <StyledArticleContent>{content}</StyledArticleContent>
  );
};

export default ArticleContent;